import React from 'react';

interface DeleteIconProps {
  onClick: () => void;
  className?: string;
}

const DeleteIcon: React.FC<DeleteIconProps> = ({ onClick, className = '' }) => (
  <svg 
    width='24' 
    height='24' 
    viewBox="0 0 1024 1024" 
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    className={`cursor-pointer hover:text-red-500 transition-colors ${className}`}
    onClick={onClick}
  >
    <path d="M512.796 829.118c11.673 0 21.135-9.462 21.135-21.133V364.143c0-11.673-9.462-21.135-21.135-21.135-11.671 0-21.135 9.462-21.135 21.135v443.842c0 11.671 9.465 21.133 21.135 21.133z m-105.676 0c11.673 0 21.135-9.462 21.135-21.133L407.12 364.143c0-11.673-9.462-21.135-21.135-21.135-11.673 0-21.133 9.462-21.133 21.135l21.133 443.842c0 11.671 9.464 21.133 21.135 21.133z m486.111-612.922H703.013v-63.404c0-46.692-37.849-84.543-84.541-84.543H407.12c-46.69 0-84.541 37.851-84.541 84.543v63.404H132.364c-11.673 0-21.137 9.462-21.137 21.137 0 11.671 9.464 21.133 21.137 21.133h88.632l59.313 612.924c0 46.69 37.851 84.539 84.543 84.539h295.891c46.692 0 84.541-37.849 84.541-84.539l59.315-612.924h88.632c11.701 0 21.135-9.462 21.135-21.133 0-11.675-9.434-21.137-21.135-21.137z m-528.379-63.404c0-23.346 18.922-42.271 42.268-42.271h211.353c23.348 0 42.271 18.924 42.271 42.271v63.404H364.852v-63.404z m338.162 718.599c0 23.344-18.924 42.268-42.271 42.268H364.852c-23.346 0-42.273-18.924-42.273-42.268l-59.315-612.924h499.065l-59.315 612.924z m-84.541-42.273c11.673 0 21.135-9.462 21.135-21.133l21.135-443.842c0-11.673-9.46-21.135-21.135-21.135-11.671 0-21.135 9.462-21.135 21.135L597.34 807.985c0 11.671 9.46 21.133 21.133 21.133z" fill="#8a8a8a"></path>
  </svg>
);

export default DeleteIcon;